import React from 'react'
import { I18nextProvider } from 'react-i18next'
import { i18next } from './index'

/**
 * Mounts the shared i18n instance for the whole app (all sites).
 * Wired in the theme's gatsby-browser/gatsby-ssr wrapRootElement, so every
 * component gets translations with no per-component setup.
 */
export const I18nProvider = ({ children }) => (
  <I18nextProvider i18n={i18next}>{children}</I18nextProvider>
)

export default I18nProvider
